module.exports = __webpack_public_path__ + "static/media/bg.5a0e0094.svg";